import { render, staticRenderFns } from "./BadgesReport.vue?vue&type=template&id=17ef18fa&scoped=true"
import script from "./BadgesReport.vue?vue&type=script&lang=js"
export * from "./BadgesReport.vue?vue&type=script&lang=js"
import style0 from "./BadgesReport.vue?vue&type=style&index=0&id=17ef18fa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17ef18fa",
  null
  
)

export default component.exports